import { Chip } from '@ipfabric/ui-components/Chip/Chip';
import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import classNames from 'classnames';
import type { TargetDropdownOptionKind } from './buildTargetDropdownOptions';

type TargetSearchOptionRowProps = {
  badgeLabel: 'Device' | 'Interface';
  dataTestId?: string;
  indented?: boolean;
  kind: TargetDropdownOptionKind;
  primaryText: string;
  secondaryText?: string;
};

export const TargetSearchOptionRow = ({
  badgeLabel,
  dataTestId,
  indented = false,
  kind,
  primaryText,
  secondaryText,
}: TargetSearchOptionRowProps) => (
  <div
    className={classNames(
      'flex w-full items-center gap-xs',
      indented && 'pl-xl',
    )}
    data-testid={dataTestId}
  >
    {indented ? (
      <Icon
        className='shrink-0 text-default'
        glyph='fa-arrow-turn-down-right'
        size='xs'
      />
    ) : null}
    <div className='min-w-0 flex-1'>
      {kind === 'device' ? (
        <span className='text-sm text-default'>
          <span>{primaryText}</span>
          {secondaryText ? (
            <span className='text-xs text-plain'>{` (${secondaryText})`}</span>
          ) : null}
        </span>
      ) : (
        <span className='text-sm text-default'>{primaryText}</span>
      )}
    </div>
    <Chip className='shrink-0' size='small' variant='plain'>
      {badgeLabel}
    </Chip>
  </div>
);
